import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import { ScanSession } from "@/views/customize/data-sources/data/model";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { UseLoading, UseLoadingAction } from "@/common/composition/loading";
import { UseTabs } from "@/common/composition/use-tabs";
import { state as info_board_state } from "../files-information/state";
import { ref } from "@vue/composition-api";
import {
  DuplicatedDashboardItem,
  FilesAgeDashboardItem,
  FileLabelingDashboardItem,
  FileSearchItem,
  FilesInformationBoardItem,
} from "./model";
import * as api from "./api";
import { UseSearch } from "@/common/composition/search";

const [loading, set_loading] = UseLoadingAction<"init" | "change_session">(
  false,
  "init"
);

const [
  sessions,
  selected_session,
  _set_selected_session,
  init_sessions,
] = UseDropdownItems<ScanSession>([]);

const set_selected_session = async (session: ScanSession) => {
  // @ts-ignore
  _set_selected_session(session);
  init_root_folders(
    // @ts-ignore
    session.root_folders || [
      { id: "folder_1", name: "folder 1 ", icon: "Folder" },
      { id: "folder_2", name: "folder 2 ", icon: "Folder" },
    ],
    0
  );
  set_loading(true, "change_session");
  await change_tab(current_tab.value!, true);
  set_loading(false, "change_session");
};

// information protection , duplicated documents , files age
const _tabs = [
  { id: "labeling", name: "Information protection" },
  { id: "duplicates", name: "Duplicated documents" },
  { id: "age", name: "Files age" },
  { id: "search", name: "Search files", icon: "Search" },
];
const [tabs, current_tab, _set_current_tab] = UseTabs(_tabs, 0);

const change_tab = async (
  tab: { id: string; name: string },
  reload = false
) => {
  if (!reload) {
    if (tab.id === current_tab.value!.id) {
      return;
    }
  }
  _set_current_tab(tab);
  await load_information_board();
  /*  switch (current_tab.value!.id) {
    case "duplicates":
      await load_duplicated_files();
      break;
    case "age":
      await load_files_age();
      break;
    case "labeling":
      await load_files_labeling();
      break;
    case "search":
    default:
      // do nothing
      break;
  } */
};

const [
  root_folders,
  current_root_folder,
  _set_current_root_folder,
  init_root_folders,
] = UseTabs<{ id: string; name: string; icon: string }>(
  [{ id: "folder_1", name: "folder 1", icon: "Folder" }],
  0
);

const change_root_folder = (folder: {
  id: string;
  name: string;
  icon: string;
}) => {
  _set_current_root_folder(folder);
  change_tab(current_tab.value!, true);
};

//#region search
const search = UseSearch<FileSearchItem>(async (q, cursor) => {
  const res = await api.search_file({
    session_id: selected_session.value!.id,
    root_folder_id: current_root_folder.value!.id,
    query: q,
    cursor,
  });
  if (res.success) {
    return res.value;
  } else {
    return {
      cursor: "",
      objects: [],
    };
  }
});
//#endregion

//#region information board
const [
  is_loading_information_board,
  set_is_loading_information_board,
] = UseLoading(false).as_arr();

const [
  information_board_tabs,
  current_information_board_tab,
  set_information_board_tab,
] = UseTabs(
  [
    { id: "sensitive", name: "Sensitive Information", icon: "Label" },
    { id: "personal", name: "Personal Information", icon: "Regulated" },
  ],
  0
);

const sensitive_information_board = ref<FilesInformationBoardItem[]>([]);
const personal_information_board = ref<FilesInformationBoardItem[]>([]);
const load_information_board = async () => {
  set_is_loading_information_board(true);
  await info_board_state.load_data({
    session_id: +selected_session.value!.id,
    root_folder_id: current_root_folder.value!.id,
  });
  /*   const res = await Promise.all([
    api.get_sensitive_information_board({
      session_id: selected_session.value!.id,
      root_folder_id: current_root_folder.value!.id,
    }),
    api.get_personal_information_board({
      session_id: selected_session.value!.id,
      root_folder_id: current_root_folder.value!.id,
    }),
  ]);

  if (res[0].success && res[1].success) {
    sensitive_information_board.value = res[0].value;
    personal_information_board.value = res[1].value;
  } */
  set_is_loading_information_board(false);
};
//#endregion

//#region duplicated_files
const duplicated_files = ref<DuplicatedDashboardItem[]>([]);
const [
  is_loading_duplicated_files,
  set_is_loading_duplicated_files,
] = UseLoading(false).as_arr();
const load_duplicated_files = async () => {
  set_is_loading_duplicated_files(true);
  const res = await api.get_duplicated_items({
    session_id: selected_session.value!.id,
    root_folder_id: current_root_folder.value!.id,
  });
  if (res.success) {
    duplicated_files.value = res.value;
  }
  set_is_loading_duplicated_files(false);
};
//#endregion

//#region files_labeling
const files_labeling = ref<FileLabelingDashboardItem[]>([]);

const [is_loading_files_labeling, set_is_loading_files_labeling] = UseLoading(
  false
).as_arr();

const load_files_labeling = async () => {
  set_is_loading_files_labeling(true);
  const res = await api.get_file_labeling({
    session_id: selected_session.value!.id,
    root_folder_id: current_root_folder.value!.id,
  });
  if (res.success) {
    files_labeling.value = res.value;
  }
  set_is_loading_files_labeling(false);
};
//#endregion

//#region files_age
const files_age = ref<FilesAgeDashboardItem[]>([]);
const [is_loading_files_age, set_is_loading_files_age] = UseLoading(
  false
).as_arr();
const load_files_age = async () => {
  set_is_loading_files_age(true);
  const res = await api.get_files_age({
    session_id: selected_session.value!.id,
    root_folder_id: current_root_folder.value!.id,
  });
  if (res.success) {
    files_age.value = res.value;
  }
  set_is_loading_files_age(false);
};
//#endregion

const init = async (force = false) => {
  set_loading(true, "init");
  await data_sources_state.init();
  const res = await data_sources_state.ext.get_sessions_for_source("onprem_fs");
  if (res.success) {
    init_sessions(res.value);
    if (sessions.value.length > 0) {
      if (force) {
        set_selected_session(sessions.value[0]);
      } else {
        set_selected_session(selected_session.value || sessions.value[0]);
      }
    }
  }
  set_loading(false, "init");
};

const destroy = () => {
  search.clearSearch();
};

export const state = {
  init,
  destroy,
  loading,
  // sessions
  sessions,
  selected_session,
  set_selected_session,
  // session root folders
  root_folders,
  current_root_folder,
  change_root_folder,
  init_root_folders,
  // tabs
  tabs,
  current_tab,
  change_tab,
  // data
  duplicated_files,
  is_loading_duplicated_files,
  files_labeling,
  is_loading_files_labeling,
  files_age,
  is_loading_files_age,
  sensitive_information_board,
  personal_information_board,
  is_loading_information_board,
  information_board_tabs,
  current_information_board_tab,
  set_information_board_tab,
  // search
  search,
};
